import { makeStyles } from '~/UIKit/Style';
import {
  VERTICAL_SEPARATOR,
  CHARCOAL_GREY,
  LIGHT_BLUE,
  WHITE,
  FADED_ICON_ERROR,
  FADED_FITOGRAM_BLUE,
} from '~/Constants/Colors.constants';
import { FONT_SIZE_LARGISH } from '~/Constants/UI.constants';

const defaultBorder = `thin solid ${VERTICAL_SEPARATOR}`;

export const ItemCreationInputTemplateStyles = (conditions: {
  isAChild: boolean;
  icon: JSX.Element | undefined;
  noIconBackground?: boolean;
  isDisabled?: boolean;
  error: boolean;
}) =>
  makeStyles(
    (theme) => ({
      inputContainer: {
        backgroundColor: conditions.error ? FADED_ICON_ERROR : WHITE,
        opacity: conditions.isDisabled ? 0.4 : 1,
        '&:first-of-type': {
          borderTop: defaultBorder,
        },
      },
      singleInputContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minHeight: 50,
        padding: '0 15px',
        position: 'relative',
        paddingLeft: conditions.isAChild ? 60 : 15,
        borderBottom: defaultBorder,
      },
      inputIcon: {
        backgroundColor: conditions.isAChild || conditions.noIconBackground ? '' : LIGHT_BLUE,
        borderRadius: 30,
        minWidth: 30,
        maxWidth: 30,
        minHeight: 30,
        maxHeight: 30,
        lineHeight: '15px',
        fontSize: FONT_SIZE_LARGISH,
        display: 'flex',
        alignItems: 'center',
        placeContent: 'center',
        marginRight: 15,
        color: CHARCOAL_GREY,
        '& > svg': {
          fontSize: 'inherit',
        },
      },
      typographyBody: {
        width: '100%',
      },
      customElement: {
        [theme.breakpoints.down('md')]: {
          background: WHITE,
          borderTop: `thin solid ${VERTICAL_SEPARATOR}`,
          borderBottom: `thin solid ${VERTICAL_SEPARATOR}`,
          padding: 15,
        },
      },
      progress: {
        marginLeft: 15,
        width: '20px!important',
        height: '20px!important',
        color: FADED_FITOGRAM_BLUE,
      },
    }),
    { name: 'ItemCreationInputTemplate' },
  );
